import { Component, effect, ElementRef, input, ViewChild } from '@angular/core';
import DOMPurify from 'dompurify';

@Component({
  selector: 'table-datatable-svg',
  templateUrl: './datatable-svg.component.html',
  styleUrls: ['./datatable-svg.component.scss'],
  imports: [],
})
export class DatatableSvgComponent {
  svg = input.required<string>();

  @ViewChild('svgContainer', { static: true }) svgContainer!: ElementRef;

  // noinspection JSUnusedGlobalSymbols
  showIconEffect = effect(() => {
    const iconHtml = DOMPurify.sanitize(this.svg());
    this.svgContainer.nativeElement.innerHTML = '';
    if (iconHtml) {
      const parser = new DOMParser();
      const svgDoc = parser.parseFromString(iconHtml, 'image/svg+xml');
      const svgElement = svgDoc.documentElement;
      svgElement.setAttribute('width', '40px');
      svgElement.setAttribute('height', '40px');
      this.svgContainer.nativeElement.appendChild(svgElement);
    }
  });
}
